/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Step_TextInputs */

const en_editor_step_text = /** @type {(inputs: Editor_Step_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions`)
};

const de_editor_step_text = /** @type {(inputs: Editor_Step_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anleitung`)
};

/**
* | output |
* | --- |
* | "Instructions" |
*
* @param {Editor_Step_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_step_text = /** @type {((inputs?: Editor_Step_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Step_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_step_text(inputs)
	return en_editor_step_text(inputs)
});